import React, { MouseEvent } from 'react';
import AddTaskIcon from '@mui/icons-material/AddTask';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { styled } from '@mui/material/styles';
import Button from '../../components/button';

interface Props {
  // record: Record, <- only used to be retrieve the
  //                    parent records' status, probably just
  //                    can pass record status optionally
  valuesForQueryConditions: any[], // The query conditions to use to filter
  // the record picker results. Defined in the form editor
  onAddTask: (e: MouseEvent<HTMLButtonElement>) => void,
  onSelectTask: (e: MouseEvent<HTMLButtonElement>) => void
  disabled: boolean,
  allowCreating?: boolean,
  onCloseClick: () => void,
  createLabel: string,
  selectRecordsTitle: string,
}

const AddNewRecordButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  marginRight: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
}));

const SelectRecordButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
}));

const TaskLinkPicker: React.FC<Props> = ({
  valuesForQueryConditions,
  onAddTask,
  onSelectTask,
  disabled,
  allowCreating = false,
  onCloseClick,
  createLabel,
  selectRecordsTitle,
}) => (
  <>
    {allowCreating && (
      <AddNewRecordButton
        size="small"
        variant="outlined"
        color="primary"
        sx={{ fontWeight: 'bold' }}
        startIcon={<AddTaskIcon />}
        onClick={onAddTask}
        data-testid="Issue-task-button"
      >
        {`Add new ${createLabel}`}
      </AddNewRecordButton>
    )}
    <SelectRecordButton
      size="small"
      variant="outlined"
      color="primary"
      sx={{ fontWeight: 'bold' }}
      startIcon={<FormatListBulletedIcon />}
      disabled={disabled}
      onClick={onSelectTask}
    >
      { selectRecordsTitle }
    </SelectRecordButton>
  </>
);
export default TaskLinkPicker;
